// extracted by mini-css-extract-plugin
export var contrastLow = "_2n-1";
export var externalLink = "_2n-2";
export var externalLinkIcon = "_2n-3";
export var link = "_2n-0";
export var linkLabel = "_2n-4";